import { Controller } from "@hotwired/stimulus";

// Validates password complexity and confirmation on the client.
// Exposes targets: password, confirmation, error, info, submit
export default class extends Controller {
  static targets = [
    "password",
    "confirmation",
    "error",
    "info",
    "submit",
  ];

  connect() {
    this.debouncedValidate = this.#debounce(this.validate.bind(this), 200);
  }

  onInput() {
    this.debouncedValidate();
  }

  validate() {
    const password = this.passwordTarget?.value || "";
    const confirmation = this.confirmationTarget?.value || "";

    const complexity = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).{8,}$/;
    const passwordValid = complexity.test(password);
    const matchValid = confirmation.length === 0 || password === confirmation;

    if (this.hasErrorTarget) {
      if (!password) {
        this.errorTarget.classList.add("hidden");
      } else if (!passwordValid) {
        this.errorTarget.textContent = "Password must be at least 8 chars and include upper, lower, number and symbol.";
        this.errorTarget.classList.remove("hidden");
      } else if (!matchValid) {
        this.errorTarget.textContent = "Passwords do not match.";
        this.errorTarget.classList.remove("hidden");
      } else {
        this.errorTarget.classList.add("hidden");
      }
    }

    if (this.hasInfoTarget) {
      if (!password || passwordValid) {
        this.infoTarget.classList.remove("hidden");
      } else {
        this.infoTarget.classList.add("hidden");
      }
    }

    if (this.hasSubmitTarget) {
      const enabled = passwordValid && matchValid;
      this.submitTarget.disabled = !enabled;
      this.submitTarget.classList.toggle("bg-gray-100", !enabled);
      this.submitTarget.classList.toggle("text-gray-400", !enabled);
      this.submitTarget.classList.toggle("bg-brand-600", enabled);
      this.submitTarget.classList.toggle("text-white", enabled);
    }
  }

  #debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }
}


